import Close from '@material-ui/icons/Close'
import React from 'react'
import { CloseButton } from 'react-toastify/dist/components'
import styles from './ConformationPopup.module.scss'

interface Props {
 handleClose: any;

btnSubmit:any;

}

const ConformationPopup: React.FC<Props> =({handleClose,btnSubmit})=> {
    return (
         <div className={styles.popup_box}>
      <div className={styles.box}>
        <span className={styles.close_icon} onClick={handleClose}><Close/></span>
        <div className={styles.popup_header}>

            <h5>Are you sure? You will be accepting orders!</h5>
          
        </div>
    
        <button className={styles.btn__submit} onClick={btnSubmit} >Resume</button>
        
        
      </div>
    </div>
    )
}

export default ConformationPopup
